import type { GenSourceKey } from '~/constants/generationSource'
import { emptyGenSourceRecord } from '~/constants/generationSource'

export type { SourceType, BgConfig } from '~/constants/generation'
export { BG_LIST } from '~/constants/generation'

// 発電形式 9 区分の唯一の SoT は `~/constants/generationSource`
// (Settings と共有、2026-09-11 昇格)。 **ここで再 export しない** — 同じ
// symbol に 2 経路ができると、 同じファイルの中でさえ直参照と page 経由が
// 混在する (2026-09-14 是正)。 利用側は `~/constants/generationSource` を
// 直接 import する。

export { GC_KOMA } from '~/constants/koma'

export type GenSeriesKey = 'genPlan' | 'genActual' | GenSourceKey

export type GenSeriesVisibility = Record<GenSeriesKey, boolean>

// 9 区分ぶんの seed は `emptyGenSourceRecord` (= tsc が網羅を強制する静的な
// SOURCE_META から作る) を使う。 `GENERATION_SOURCE_LIST` も実行時には 9 件
// 揃うが、 その 9 件性は `DEFAULT_STACK_ORDER` の網羅に依存する
// (詳細は generationSource.ts の `emptyGenSourceRecord` docstring)。
export const DEFAULT_GEN_SERIES_VISIBILITY: GenSeriesVisibility = {
  genPlan: true,
  genActual: true,
  ...emptyGenSourceRecord(true),
}
